import { render } from "./QuestionEditPage.vue?vue&type=template&id=747ab288&scoped=true"
import script from "./QuestionEditPage.vue?vue&type=script&lang=js"
export * from "./QuestionEditPage.vue?vue&type=script&lang=js"

import "./QuestionEditPage.vue?vue&type=style&index=0&id=747ab288&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747ab288"]])

export default __exports__